// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T1Qi","importantInfo":"styles_importantInfo__2H0hZ"};